import { useEffect, useState, useRef } from 'react';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import {
    Typography,
    Popover,
    FormControl,
} from '@material-ui/core';
import {
} from './../handler/ShareStatusKnowledgeHandler';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { Button } from '@material-ui/core';
import './ListItemTagField.css';
import {
    bulkActionHelpdeskTaskIdAtom,
    bulkActionKnowledgeTaskIdAtom,
} from '@/state/atom/ticketKnowledgeAtom';
import { cloneDeep } from 'lodash';
import { handleBulkUpdateTicketAPI, handleMsgPendingWhenBulkActionInProcessing } from '../handler/ListTicketKnowledgeHandler';
import { useSnackbar } from 'notistack';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { userAtom } from '@/state/atom/userAtom';
import RenderTagItemMultiChoice from './RenderTagItemMultiChoice';
import I18n from '@/rI18n';

function ListItemOfSelectedTagField(props) {
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const userDetail = useRecoilValue(userAtom);

    const [openShareStatusPopover, setOpenShareStatusPopover] = useState('');
    const idPopoverShareStatus = openShareStatusPopover ? 'simple-popover' : undefined;
    const [shareStatusPopover, setShareStatusPopover] = useState(false);
    const [listItem,setListItem] = useState([]);
    const setKnowledgeTaskId = useSetRecoilState(bulkActionKnowledgeTaskIdAtom);
    const setHelpDeskTaskId = useSetRecoilState(bulkActionHelpdeskTaskIdAtom);
    const { enqueueSnackbar } = useSnackbar();
    const isProjectManager = useRecoilValue(isManagerByProjectInuseSelector);
    const [isDisable,setIsDisable] = useState(false);
    const [isOnChange,setIsOnChange] = useState(false);
    const [maxItemShow, setMaxItemShow] = useState(Constant.BULK_ACTION_DEFAULT_VALUE.TAG_ITEM_DISPLAY);

    useEffect(() => {
        let selectedFieldId = props?.selectedTagField?.id;
        let drillDataOfField = props.drillDownData?.find(drillDownItem => {
            return drillDownItem?.id === selectedFieldId
        });
        // console.log('useEffect :>>-------------------- ', 1);
        let listItemOfTagField = [];
        if(!Utils.isEmptyObject(drillDataOfField)){
            let listItemSelectedOfField = drillDataOfField.child;

            props.listTagItem?.forEach(itemDetail => {
                if (itemDetail?.structure?.isShowItemInTicket) {
                    // console.log('itemDetail :>>------------- ', itemDetail);
                    let itemInfo = {
                        id: itemDetail.id,
                        name: itemDetail.name,
                        no: itemDetail?.structure?.no,
                        status: 'uncheck',
                        isTagMaster: itemDetail?.isTagMaster
                    };

                    let dataDrillDownOfItem = listItemSelectedOfField?.find(
                        item => item.id === itemDetail.id
                    );
                    if (dataDrillDownOfItem) {
                        itemInfo.indeterminate = dataDrillDownOfItem.total >= props.totalTickets ? false : true;
                        itemInfo.status = dataDrillDownOfItem.total >= props.totalTickets ? 'checked' : 'indeterminate'
                        itemInfo.total = dataDrillDownOfItem.total;
                    }
                    listItemOfTagField.push(itemInfo);
                }
            });
        }else{
            props.listTagItem?.forEach(itemDetail => {
                if (itemDetail?.structure?.isShowItemInTicket) {
                    // console.log('itemDetail :>>------------- ', itemDetail);
                    let itemInfo = {
                        id: itemDetail.id,
                        name: itemDetail.name,
                        no: itemDetail?.structure?.no,
                        status: 'uncheck',
                        isTagMaster: itemDetail?.isTagMaster
                    };
                    listItemOfTagField.push(itemInfo);
                }
            });
        }
        listItemOfTagField = Utils?.sortDrillDownByNo(listItemOfTagField)
        // console.log('listItemOfTagField :>>------------ ', listItemOfTagField);
        setListItem(listItemOfTagField)

    }, [props.drillDownData, props.listTagItem,props.totalTickets,props?.selectedTagField]);

    useEffect(() => {
        if (props?.selectedTagField?.required) {
            let listItemIsCheck = listItem?.filter(item => {
                if (item.status === 'checked') {
                    return true;
                } else {
                    return false;
                }
            });
            if (Utils.isEmptyArray(listItemIsCheck)) {
                setIsDisable(true);
            } else {
                setIsDisable(false);
            }
        } else {
            setIsDisable(false);
        }
    }, [listItem]);

    useEffect(()=>{
        setIsOnChange(false)
    },[props?.selectedTagField])


    const handleOnChange = (item) => {
        let itemClone = cloneDeep(item)
            switch (item.status) {
                case 'checked':
                    itemClone.status = 'uncheck'
                    break;
                case 'indeterminate':
                    itemClone.status = 'checked'
                    itemClone.indeterminate = false
                    break;
                case 'uncheck':
                    itemClone.status = 'checked'
                    break;

                default:
                    break;
            }
        let indexOfActionItem = listItem?.findIndex(itemDetail => itemDetail.id=== item.id);
        if(indexOfActionItem >= 0){
            setIsOnChange(true)
            let listItemClone = cloneDeep(listItem);
            listItemClone[indexOfActionItem] = itemClone
            setListItem([...listItemClone])
        }
    }

    const handleSubmitEditTagFields = async () => {
        setMaxItemShow(Constant.BULK_ACTION_DEFAULT_VALUE.TAG_ITEM_DISPLAY);
        if (props.totalTickets > Constant.LIMIT_TICKET_UPDATE_MULTI) {
            props.setIsShowEditTagField(false);
            props.setIsShowDialogNotiLimit(true);
            return;
        }

        let listItemObject = listItem?.filter(item => !item.indeterminate).map(item => {
            let itemObject =  {itemId: item.id};
            if(item.status === 'checked'){
                itemObject.isCheckAll = true
            };
            if(item.status === 'uncheck'){
                itemObject.uncheckAll = true
            }

            return itemObject;
        });

        let params = {
            searchCondition: JSON.stringify({
                listItem: listItemObject,
                tagFieldId: props?.selectedTagField?.id,
                isProjectManager: isProjectManager,
                ...props.currentSearchParams,
                userAffiliationOrganization: userDetail?.affiliationOrganization || props?.currentSearchParams?.corporationId,
                projectInuse: projectInuseDetail?.id,
                formId: props.selectedFormId,
                userId: userDetail?.id,
                corporationInuse: userDetail?.affiliationOrganization
            }),
            action: props?.action
        };
        props.setIsShowEditTagField(false);
        document.body.style.cursor='wait';
        let setTaskId =  props?.action === Constant.BULK_ACTION.HELPDESK_EDIT_TAG_FIELD ? setHelpDeskTaskId : setKnowledgeTaskId
        handleBulkUpdateTicketAPI(
            {params: params},
            null, //setIsOpenDialogConfirm
            setTaskId,
            false,
            enqueueSnackbar,
            props.setIsOpenAlertDialog
        )
       
        props.setMsgInProcessingIcon(
            handleMsgPendingWhenBulkActionInProcessing(props?.action)
        );
        
    }

    const renderListBasicView = () => {
        let itemList = [];
        let projectList = [];
        if (props?.selectedTagField?.sysField === Constant.SYSTEM_FIELD.BUSINESS_APP_USE_RANGE) {
            for (let i = 0; i < listItem.length; i++) {
                if (i >= maxItemShow) continue;
                let item = listItem[i];
                if (Utils.getPrefixOfId(item?.id) === Constant.ID_PREFIX.PROJECT) {
                    projectList.push(listItem[i]);
                } else {
                    itemList.push(
                        <RenderTagItemMultiChoice
                            value={item?.name}
                            name={item?.name}
                            status={item?.status}
                            indeterminate={item?.indeterminate}
                            handleOnChange={handleOnChange}
                            item={item}
                            id={item?.id}
                            key={`${item?.id}-tag-item-display`}
                            isTagMaster={item?.isTagMaster}
                            maxItemShow={maxItemShow}
                        />
                    );
                }
            }

            //sort like ticket detail
            const projectInuseItem = projectList.find(prj => prj.id === projectInuseDetail?.id);
            let otherProjectItems = projectList.filter(prj => prj.id !== projectInuseDetail?.id)
            otherProjectItems = Utils.sortListBookmarkByNameASC(otherProjectItems);
            const sortedProjectItems = [projectInuseItem, ...otherProjectItems].filter(Boolean);
            const total = sortedProjectItems.length;
            projectList = sortedProjectItems.map((item, idx) => {
                return {
                    ...item,
                    no: (idx + 1) / (total + 1)
                }
            });
            
            projectList = projectList.map(item => {
                return (
                    <RenderTagItemMultiChoice
                    value={item?.name}
                    name={item?.name}
                    status={item?.status}
                    indeterminate={item?.indeterminate}
                    handleOnChange={handleOnChange}
                    item={item}
                    id={item?.id}
                    key={`${item?.id}-tag-item-display`}
                    isTagMaster={item?.isTagMaster}
                    maxItemShow={maxItemShow}
                />
                );
            });

            return (
                <FormControl
                    component="fieldset"
                    className="list-item-of-tag"
                    id={`form-control-share-status-all`}
                >
                    <span className="bookmark-group-label">{I18n.get('USER04BTN007')}</span>
                    {projectList}
                    <span className="bookmark-group-label">{I18n.get('LABEL-FUNCTION-OTHER')}</span>
                    {itemList}
                </FormControl>
            );
        }

        for (let i = 0; i < listItem.length; i++) {
            if (i >= maxItemShow) continue;
            let item = listItem[i];

            itemList.push(
                <RenderTagItemMultiChoice
                    value={item?.name}
                    name={item?.name}
                    status={item?.status}
                    indeterminate={item?.indeterminate}
                    handleOnChange={handleOnChange}
                    item={item}
                    id={item?.id}
                    key={`${item?.id}-tag-item-display`}
                    isTagMaster={item?.isTagMaster}
                    maxItemShow={maxItemShow}
                />
            )
        }

        return (
            <FormControl
                component="fieldset"
                className="list-item-of-tag"
                id={`form-control-share-status-all`}
            >
                {itemList}

            </FormControl>
        );
    };

    const handleClickShowShareStatus = (
        event
    ) => {
        setOpenShareStatusPopover(true);
        props.setIsShowListItemOfTagField(true)
        setShareStatusPopover(event.currentTarget);
    };

    const handleClosePopoverShareStatus = async () => {
        setShareStatusPopover(null);
        setOpenShareStatusPopover(false);
        props.setIsShowListItemOfTagField(false)
    }

    const handleOnScrollTagItem = event => {
        let elementWhenScroll = event.target;
        if (
            elementWhenScroll.offsetHeight + elementWhenScroll.scrollTop >=
            elementWhenScroll.scrollHeight
        ) {
            setMaxItemShow(prev => parseInt(prev + 15));
        }
    };

    return (
        <div className="">
            <Typography
                className=""
                aria-describedby={idPopoverShareStatus}
                variant="contained"
                onClick={e => {
                    handleClickShowShareStatus(e);
                }}
            >
                {' '}
                <img src="/assets/image/edit-setting-public-url.svg" alt="icon-edit-range" />
            </Typography>
            <Popover
                className="share-status-popover"
                id={idPopoverShareStatus}
                key={`popover-share-status-all`}
                open={openShareStatusPopover}
                anchorEl={shareStatusPopover}
                onClose={e => {
                    handleClosePopoverShareStatus();
                    setMaxItemShow(Constant.BULK_ACTION_DEFAULT_VALUE.TAG_ITEM_DISPLAY);
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                PaperProps={{
                    style: {
                        marginTop: '12px',
                        marginLeft: '7px',
                        borderRadius: '8px',
                        minWidth: '300px'
                    }
                }}
            >
                <div>
                    <div
                        className="listView knowledge-share-public-status-list"
                        id={`share_status_id_all`}
                    >
                        <div
                            className="list-permission-status list-item-selected-tag-field"
                            onScroll={e => handleOnScrollTagItem(e)}
                        >
                            {renderListBasicView()}
                        </div>
                        <div className="share-status-popover-additional">
                            <Button
                                className="btn-send btn-primary btn-hg32"
                                variant="contained"
                                color="primary"
                                onClick={e => handleSubmitEditTagFields()}
                                disabled={isDisable || !isOnChange}
                            >
                                適用
                            </Button>
                        </div>
                    </div>
                </div>
            </Popover>
        </div>
    );
}

export default ListItemOfSelectedTagField;